export default __webpack_public_path__ + "static/greycliff-cf-bold-88167f7d0250f55bb5d08f1c3cb15693.woff2";